/* eslint-disable */
// @ts-nocheck

import {
  ListValue, 
	Value, 
	Struct
} from "@bufbuild/protobuf";
import * as reboot_api from "@reboot-dev/reboot-api";
import * as reboot_web from "@reboot-dev/reboot-web";
import { v4 as uuidv4 } from "uuid";
// NOTE NOTE NOTE
//
// If you are reading this comment because you are trying to debug
// the error:
//
// Module not found: Error: Can't resolve './store_pb.js'
//
// You can resolve this by passing --web-extensions to `rbt
// generate` (or better put it in your `.rbtrc` file).
//
// This is a known issue if you're using `webpack` which uses
// `ts-loader` (https://github.com/TypeStrong/ts-loader/issues/465).
import {
  StoreV2 as StoreV2Proto,
} from "./store_pb";
import * as store_pb from "./store_pb";
// Additionally re-export all messages_and_enums from the pb module.
export {
  TableSchema,
  InsertOp,
  DeleteOp,
  ReplaceOp,
  UpsertOp,
  CreateTableOp,
  DropTableOp,
  Operation,
  ChangeEntry,
  TableRows,
  CreateTableRequest,
  CreateTableResponse,
  DropTableRequest,
  DropTableResponse,
  EnsureCreatedRequest,
  EnsureCreatedResponse,
  MutateRequest,
  MutateResponse,
  SnapshotRequest,
  SnapshotResponse,
  ChangesRequest,
  ChangesResponse,
} from "./store_pb";

import * as protobuf_es from "@bufbuild/protobuf";

reboot_api.check_bufbuild_protobuf_library(protobuf_es.Message);



const ERROR_TYPES = [
  // gRPC errors.
  reboot_api.errors_pb.Cancelled,
  reboot_api.errors_pb.Unknown,
  reboot_api.errors_pb.InvalidArgument,
  reboot_api.errors_pb.DeadlineExceeded,
  reboot_api.errors_pb.NotFound,
  reboot_api.errors_pb.AlreadyExists,
  reboot_api.errors_pb.PermissionDenied,
  reboot_api.errors_pb.ResourceExhausted,
  reboot_api.errors_pb.FailedPrecondition,
  reboot_api.errors_pb.Aborted,
  reboot_api.errors_pb.OutOfRange,
  reboot_api.errors_pb.Unimplemented,
  reboot_api.errors_pb.Internal,
  reboot_api.errors_pb.Unavailable,
  reboot_api.errors_pb.DataLoss,
  reboot_api.errors_pb.Unauthenticated,
  // Reboot errors.
  //
  // NOTE: also add any new errors into `rbt/v1alpha1/index.ts`.
  reboot_api.errors_pb.StateAlreadyConstructed,
  reboot_api.errors_pb.StateNotConstructed,
  reboot_api.errors_pb.TransactionParticipantFailedToPrepare,
  reboot_api.errors_pb.TransactionParticipantFailedToCommit,
  reboot_api.errors_pb.UnknownService,
  reboot_api.errors_pb.UnknownTask,
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!


// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const StoreV2CreateTableRequestFromProtobufShape = (
  partialRequest: protobuf_es.PartialMessage<store_pb.CreateTableRequest>
): StoreV2.CreateTableRequest => {
  // TOOD: update `protoToZod()` to actually work from
  // any objects that match the shape, not just protobuf instances,
  // and then we won't need to first call `fromJson()` here.
  const request = partialRequest instanceof store_pb.CreateTableRequest
    ? partialRequest
    : store_pb.CreateTableRequest.fromJson(partialRequest);

  return request;
};

// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const StoreV2CreateTableRequestFromJsonString = (
  jsonRequest: string
): StoreV2.CreateTableRequest => {
  return StoreV2CreateTableRequestFromProtobufShape(
    store_pb.CreateTableRequest.fromJsonString(jsonRequest)
  );
};

// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const StoreV2CreateTableRequestToProtobuf = (
  partialRequest?: StoreV2.PartialCreateTableRequest
): store_pb.CreateTableRequest => {
  return partialRequest instanceof store_pb.CreateTableRequest
    ? partialRequest
    : new store_pb.CreateTableRequest(
      partialRequest
    );
};

const StoreV2CreateTableResponseFromProtobufShape = (
  partialResponse: protobuf_es.PartialMessage<store_pb.CreateTableResponse>
) => {
  // TOOD: update `protoToZod()` to actually work from
  // any objects that match the shape, not just protobuf instances,
  // and then we won't need to first call `fromJson()` here.
  const response = partialResponse instanceof store_pb.CreateTableResponse
    ? partialResponse
    : store_pb.CreateTableResponse.fromJson(partialResponse);

  return response;
};

const StoreV2CreateTableResponseToProtobuf = (
  partialResponse?: StoreV2.PartialCreateTableResponse
): store_pb.CreateTableResponse => {
  return partialResponse instanceof store_pb.CreateTableResponse
    ? partialResponse
    : new store_pb.CreateTableResponse(
      partialResponse
    );
};


// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const StoreV2DropTableRequestFromProtobufShape = (
  partialRequest: protobuf_es.PartialMessage<store_pb.DropTableRequest>
): StoreV2.DropTableRequest => {
  // TOOD: update `protoToZod()` to actually work from
  // any objects that match the shape, not just protobuf instances,
  // and then we won't need to first call `fromJson()` here.
  const request = partialRequest instanceof store_pb.DropTableRequest
    ? partialRequest
    : store_pb.DropTableRequest.fromJson(partialRequest);

  return request;
};

// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const StoreV2DropTableRequestFromJsonString = (
  jsonRequest: string
): StoreV2.DropTableRequest => {
  return StoreV2DropTableRequestFromProtobufShape(
    store_pb.DropTableRequest.fromJsonString(jsonRequest)
  );
};

// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const StoreV2DropTableRequestToProtobuf = (
  partialRequest?: StoreV2.PartialDropTableRequest
): store_pb.DropTableRequest => {
  return partialRequest instanceof store_pb.DropTableRequest
    ? partialRequest
    : new store_pb.DropTableRequest(
      partialRequest
    );
};

const StoreV2DropTableResponseFromProtobufShape = (
  partialResponse: protobuf_es.PartialMessage<store_pb.DropTableResponse>
) => {
  // TOOD: update `protoToZod()` to actually work from
  // any objects that match the shape, not just protobuf instances,
  // and then we won't need to first call `fromJson()` here.
  const response = partialResponse instanceof store_pb.DropTableResponse
    ? partialResponse
    : store_pb.DropTableResponse.fromJson(partialResponse);

  return response;
};

const StoreV2DropTableResponseToProtobuf = (
  partialResponse?: StoreV2.PartialDropTableResponse
): store_pb.DropTableResponse => {
  return partialResponse instanceof store_pb.DropTableResponse
    ? partialResponse
    : new store_pb.DropTableResponse(
      partialResponse
    );
};


// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const StoreV2EnsureCreatedRequestFromProtobufShape = (
  partialRequest: protobuf_es.PartialMessage<store_pb.EnsureCreatedRequest>
): StoreV2.EnsureCreatedRequest => {
  // TOOD: update `protoToZod()` to actually work from
  // any objects that match the shape, not just protobuf instances,
  // and then we won't need to first call `fromJson()` here.
  const request = partialRequest instanceof store_pb.EnsureCreatedRequest
    ? partialRequest
    : store_pb.EnsureCreatedRequest.fromJson(partialRequest);

  return request;
};

// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const StoreV2EnsureCreatedRequestFromJsonString = (
  jsonRequest: string
): StoreV2.EnsureCreatedRequest => {
  return StoreV2EnsureCreatedRequestFromProtobufShape(
    store_pb.EnsureCreatedRequest.fromJsonString(jsonRequest)
  );
};

// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const StoreV2EnsureCreatedRequestToProtobuf = (
  partialRequest?: StoreV2.PartialEnsureCreatedRequest
): store_pb.EnsureCreatedRequest => {
  return partialRequest instanceof store_pb.EnsureCreatedRequest
    ? partialRequest
    : new store_pb.EnsureCreatedRequest(
      partialRequest
    );
};

const StoreV2EnsureCreatedResponseFromProtobufShape = (
  partialResponse: protobuf_es.PartialMessage<store_pb.EnsureCreatedResponse>
) => {
  // TOOD: update `protoToZod()` to actually work from
  // any objects that match the shape, not just protobuf instances,
  // and then we won't need to first call `fromJson()` here.
  const response = partialResponse instanceof store_pb.EnsureCreatedResponse
    ? partialResponse
    : store_pb.EnsureCreatedResponse.fromJson(partialResponse);

  return response;
};

const StoreV2EnsureCreatedResponseToProtobuf = (
  partialResponse?: StoreV2.PartialEnsureCreatedResponse
): store_pb.EnsureCreatedResponse => {
  return partialResponse instanceof store_pb.EnsureCreatedResponse
    ? partialResponse
    : new store_pb.EnsureCreatedResponse(
      partialResponse
    );
};


// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const StoreV2MutateRequestFromProtobufShape = (
  partialRequest: protobuf_es.PartialMessage<store_pb.MutateRequest>
): StoreV2.MutateRequest => {
  // TOOD: update `protoToZod()` to actually work from
  // any objects that match the shape, not just protobuf instances,
  // and then we won't need to first call `fromJson()` here.
  const request = partialRequest instanceof store_pb.MutateRequest
    ? partialRequest
    : store_pb.MutateRequest.fromJson(partialRequest);

  return request;
};

// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const StoreV2MutateRequestFromJsonString = (
  jsonRequest: string
): StoreV2.MutateRequest => {
  return StoreV2MutateRequestFromProtobufShape(
    store_pb.MutateRequest.fromJsonString(jsonRequest)
  );
};

// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const StoreV2MutateRequestToProtobuf = (
  partialRequest?: StoreV2.PartialMutateRequest
): store_pb.MutateRequest => {
  return partialRequest instanceof store_pb.MutateRequest
    ? partialRequest
    : new store_pb.MutateRequest(
      partialRequest
    );
};

const StoreV2MutateResponseFromProtobufShape = (
  partialResponse: protobuf_es.PartialMessage<store_pb.MutateResponse>
) => {
  // TOOD: update `protoToZod()` to actually work from
  // any objects that match the shape, not just protobuf instances,
  // and then we won't need to first call `fromJson()` here.
  const response = partialResponse instanceof store_pb.MutateResponse
    ? partialResponse
    : store_pb.MutateResponse.fromJson(partialResponse);

  return response;
};

const StoreV2MutateResponseToProtobuf = (
  partialResponse?: StoreV2.PartialMutateResponse
): store_pb.MutateResponse => {
  return partialResponse instanceof store_pb.MutateResponse
    ? partialResponse
    : new store_pb.MutateResponse(
      partialResponse
    );
};


// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const StoreV2SnapshotRequestFromProtobufShape = (
  partialRequest: protobuf_es.PartialMessage<store_pb.SnapshotRequest>
): StoreV2.SnapshotRequest => {
  // TOOD: update `protoToZod()` to actually work from
  // any objects that match the shape, not just protobuf instances,
  // and then we won't need to first call `fromJson()` here.
  const request = partialRequest instanceof store_pb.SnapshotRequest
    ? partialRequest
    : store_pb.SnapshotRequest.fromJson(partialRequest);

  return request;
};

// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const StoreV2SnapshotRequestFromJsonString = (
  jsonRequest: string
): StoreV2.SnapshotRequest => {
  return StoreV2SnapshotRequestFromProtobufShape(
    store_pb.SnapshotRequest.fromJsonString(jsonRequest)
  );
};

// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const StoreV2SnapshotRequestToProtobuf = (
  partialRequest?: StoreV2.PartialSnapshotRequest
): store_pb.SnapshotRequest => {
  return partialRequest instanceof store_pb.SnapshotRequest
    ? partialRequest
    : new store_pb.SnapshotRequest(
      partialRequest
    );
};

const StoreV2SnapshotResponseFromProtobufShape = (
  partialResponse: protobuf_es.PartialMessage<store_pb.SnapshotResponse>
) => {
  // TOOD: update `protoToZod()` to actually work from
  // any objects that match the shape, not just protobuf instances,
  // and then we won't need to first call `fromJson()` here.
  const response = partialResponse instanceof store_pb.SnapshotResponse
    ? partialResponse
    : store_pb.SnapshotResponse.fromJson(partialResponse);

  return response;
};

const StoreV2SnapshotResponseToProtobuf = (
  partialResponse?: StoreV2.PartialSnapshotResponse
): store_pb.SnapshotResponse => {
  return partialResponse instanceof store_pb.SnapshotResponse
    ? partialResponse
    : new store_pb.SnapshotResponse(
      partialResponse
    );
};


// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a protobuf shape.
const StoreV2ChangesRequestFromProtobufShape = (
  partialRequest: protobuf_es.PartialMessage<store_pb.ChangesRequest>
): StoreV2.ChangesRequest => {
  // TOOD: update `protoToZod()` to actually work from
  // any objects that match the shape, not just protobuf instances,
  // and then we won't need to first call `fromJson()` here.
  const request = partialRequest instanceof store_pb.ChangesRequest
    ? partialRequest
    : store_pb.ChangesRequest.fromJson(partialRequest);

  return request;
};

// Helper for getting the expected shape of a request, i.e., either a
// Zod shape or a protobuf instance, from a JSON string.
const StoreV2ChangesRequestFromJsonString = (
  jsonRequest: string
): StoreV2.ChangesRequest => {
  return StoreV2ChangesRequestFromProtobufShape(
    store_pb.ChangesRequest.fromJsonString(jsonRequest)
  );
};

// Helper for getting a protobuf instance for a request from the
// expected shape, i.e., either a Zod shape or a protobuf shape.
const StoreV2ChangesRequestToProtobuf = (
  partialRequest?: StoreV2.PartialChangesRequest
): store_pb.ChangesRequest => {
  return partialRequest instanceof store_pb.ChangesRequest
    ? partialRequest
    : new store_pb.ChangesRequest(
      partialRequest
    );
};

const StoreV2ChangesResponseFromProtobufShape = (
  partialResponse: protobuf_es.PartialMessage<store_pb.ChangesResponse>
) => {
  // TOOD: update `protoToZod()` to actually work from
  // any objects that match the shape, not just protobuf instances,
  // and then we won't need to first call `fromJson()` here.
  const response = partialResponse instanceof store_pb.ChangesResponse
    ? partialResponse
    : store_pb.ChangesResponse.fromJson(partialResponse);

  return response;
};

const StoreV2ChangesResponseToProtobuf = (
  partialResponse?: StoreV2.PartialChangesResponse
): store_pb.ChangesResponse => {
  return partialResponse instanceof store_pb.ChangesResponse
    ? partialResponse
    : new store_pb.ChangesResponse(
      partialResponse
    );
};



export namespace StoreV2 {
  export type CreateTableRequest =
    store_pb.CreateTableRequest;

  export type PartialCreateTableRequest =
  protobuf_es.PartialMessage<store_pb.CreateTableRequest>;

  export type CreateTableResponse =
    store_pb.CreateTableResponse;

  export type PartialCreateTableResponse =
  protobuf_es.PartialMessage<store_pb.CreateTableResponse>;
}
export namespace StoreV2 {
  export type DropTableRequest =
    store_pb.DropTableRequest;

  export type PartialDropTableRequest =
  protobuf_es.PartialMessage<store_pb.DropTableRequest>;

  export type DropTableResponse =
    store_pb.DropTableResponse;

  export type PartialDropTableResponse =
  protobuf_es.PartialMessage<store_pb.DropTableResponse>;
}
export namespace StoreV2 {
  export type EnsureCreatedRequest =
    store_pb.EnsureCreatedRequest;

  export type PartialEnsureCreatedRequest =
  protobuf_es.PartialMessage<store_pb.EnsureCreatedRequest>;

  export type EnsureCreatedResponse =
    store_pb.EnsureCreatedResponse;

  export type PartialEnsureCreatedResponse =
  protobuf_es.PartialMessage<store_pb.EnsureCreatedResponse>;
}
export namespace StoreV2 {
  export type MutateRequest =
    store_pb.MutateRequest;

  export type PartialMutateRequest =
  protobuf_es.PartialMessage<store_pb.MutateRequest>;

  export type MutateResponse =
    store_pb.MutateResponse;

  export type PartialMutateResponse =
  protobuf_es.PartialMessage<store_pb.MutateResponse>;
}
export namespace StoreV2 {
  export type SnapshotRequest =
    store_pb.SnapshotRequest;

  export type PartialSnapshotRequest =
  protobuf_es.PartialMessage<store_pb.SnapshotRequest>;

  export type SnapshotResponse =
    store_pb.SnapshotResponse;

  export type PartialSnapshotResponse =
  protobuf_es.PartialMessage<store_pb.SnapshotResponse>;
}
export namespace StoreV2 {
  export type ChangesRequest =
    store_pb.ChangesRequest;

  export type PartialChangesRequest =
  protobuf_es.PartialMessage<store_pb.ChangesRequest>;

  export type ChangesResponse =
    store_pb.ChangesResponse;

  export type PartialChangesResponse =
  protobuf_es.PartialMessage<store_pb.ChangesResponse>;
}



const STORE_V_2_CREATE_TABLE_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type StoreV2CreateTableAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof STORE_V_2_CREATE_TABLE_ERROR_TYPES
  >[number];

export class StoreV2CreateTableAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      STORE_V_2_CREATE_TABLE_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new StoreV2CreateTableAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new StoreV2CreateTableAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.#error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.#error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: StoreV2CreateTableAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.#error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.#error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.#error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  get error() {
    reboot_api.assert(this.#error instanceof protobuf_es.Message);
    return this.#error;
  }

  readonly #error: StoreV2CreateTableAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}



const STORE_V_2_DROP_TABLE_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type StoreV2DropTableAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof STORE_V_2_DROP_TABLE_ERROR_TYPES
  >[number];

export class StoreV2DropTableAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      STORE_V_2_DROP_TABLE_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new StoreV2DropTableAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new StoreV2DropTableAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.#error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.#error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: StoreV2DropTableAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.#error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.#error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.#error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  get error() {
    reboot_api.assert(this.#error instanceof protobuf_es.Message);
    return this.#error;
  }

  readonly #error: StoreV2DropTableAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}



const STORE_V_2_ENSURE_CREATED_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type StoreV2EnsureCreatedAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof STORE_V_2_ENSURE_CREATED_ERROR_TYPES
  >[number];

export class StoreV2EnsureCreatedAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      STORE_V_2_ENSURE_CREATED_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new StoreV2EnsureCreatedAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new StoreV2EnsureCreatedAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.#error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.#error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: StoreV2EnsureCreatedAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.#error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.#error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.#error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  get error() {
    reboot_api.assert(this.#error instanceof protobuf_es.Message);
    return this.#error;
  }

  readonly #error: StoreV2EnsureCreatedAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}



const STORE_V_2_MUTATE_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type StoreV2MutateAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof STORE_V_2_MUTATE_ERROR_TYPES
  >[number];

export class StoreV2MutateAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      STORE_V_2_MUTATE_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new StoreV2MutateAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new StoreV2MutateAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.#error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.#error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: StoreV2MutateAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.#error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.#error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.#error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  get error() {
    reboot_api.assert(this.#error instanceof protobuf_es.Message);
    return this.#error;
  }

  readonly #error: StoreV2MutateAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}



const STORE_V_2_SNAPSHOT_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type StoreV2SnapshotAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof STORE_V_2_SNAPSHOT_ERROR_TYPES
  >[number];

export class StoreV2SnapshotAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      STORE_V_2_SNAPSHOT_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new StoreV2SnapshotAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new StoreV2SnapshotAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.#error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.#error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: StoreV2SnapshotAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.#error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.#error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.#error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  get error() {
    reboot_api.assert(this.#error instanceof protobuf_es.Message);
    return this.#error;
  }

  readonly #error: StoreV2SnapshotAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}



const STORE_V_2_CHANGES_ERROR_TYPES = [
  ...ERROR_TYPES,

  // Method errors.
] as const; // Need `as const` to ensure TypeScript infers this as a tuple!

export type StoreV2ChangesAbortedError =
  reboot_api.InstanceTypeForErrorTypes<
    typeof STORE_V_2_CHANGES_ERROR_TYPES
  >[number];

export class StoreV2ChangesAborted extends reboot_api.Aborted {
  static fromStatus(status: reboot_api.Status) {
    let error = reboot_api.errorFromGoogleRpcStatusDetails(
      status,
      STORE_V_2_CHANGES_ERROR_TYPES,
    );

    if (error !== undefined) {
      return new StoreV2ChangesAborted(
        error, { message: status.message }
      );
    }

    error = reboot_api.errorFromGoogleRpcStatusCode(status);

    // TODO(benh): also consider getting the type names from
    // `status.details` and including that in `message` to make
    // debugging easier.

    return new StoreV2ChangesAborted(
      error, { message: status.message }
    );
  }

  public toStatus(): reboot_api.Status {
    const isObject = (value: unknown): value is object => {
      return typeof value === 'object';
    };

    const isArray = (value: unknown): value is any[]  => {
      return Array.isArray(value);
    };

    const error = this.#error.toJson();

    if (!isObject(error) || isArray(error)) {
      throw new Error("Expecting 'error' to be an object (and not an array)");
    }

    const detail = { ...error };
    detail["@type"] = `type.googleapis.com/${this.#error.getType().typeName}`;

    return new reboot_api.Status({
      code: this.code,
      message: this.#message,
      details: [detail]
    });
  }

  constructor(
    error: StoreV2ChangesAbortedError,
    { message }: { message?: string } = {}
  ) {
    super();

    // Set the name of this error for even more information!
    this.name = this.constructor.name;

    this.#error = error;

    let code = reboot_api.grpcStatusCodeFromError(this.#error);

    if (code === undefined) {
      // Must be one of the Reboot specific errors.
      code = reboot_api.StatusCode.ABORTED;
    }

    this.code = code;

    this.#message = message;
  }

  toString(): string {
    return `${this.name}: ${this.message}`;
  }

  get message(): string {
    return `${this.#error.getType().typeName}${this.#message ? ": " + this.#message : ""}`;
  }

  get error() {
    reboot_api.assert(this.#error instanceof protobuf_es.Message);
    return this.#error;
  }

  readonly #error: StoreV2ChangesAbortedError;
  readonly code: reboot_api.StatusCode;
  readonly #message?: string;
}


class _Reactively {
  #id: string;
  #state: string;

  constructor(id: string, options?: reboot_api.CallOptions) {
    this.#id = id;
    this.#state = "dev.moment.differential.v1alpha2.StoreV2";
  }

  async snapshot(
    context: reboot_web.WebContext,
    partialRequest?: StoreV2.PartialSnapshotRequest,
    options?: { signal?: AbortSignal },
  ): Promise<[
      AsyncGenerator<StoreV2.SnapshotResponse, void, unknown>,
      (newRequest: StoreV2.PartialSnapshotRequest) => void
    ]> {
    const request = StoreV2SnapshotRequestToProtobuf(partialRequest);

    const [generator, setRequest] = reboot_web.reactively(
      {
        url: context.url,
        state: this.#state,
        method: "Snapshot",
        id: this.#id,
        requestType: store_pb.SnapshotRequest,
        responseType: store_pb.SnapshotResponse,
        request: request,
        signal: options?.signal,
        bearerToken: context.bearerToken,
        websockets: context.websockets,
      }
    );

    const setTypedRequest = (newRequest: StoreV2.PartialSnapshotRequest): void => {
      const typedRequest = StoreV2SnapshotRequestToProtobuf(newRequest);
      setRequest(typedRequest);
    };

    async function* typedGenerator(): AsyncGenerator<StoreV2.SnapshotResponse, void, unknown> {
     for await (const response of generator) {
      const typedResponse = StoreV2SnapshotResponseFromProtobufShape(response);
      yield typedResponse;
      }
    };

    return [typedGenerator(), setTypedRequest];
  }

  async changes(
    context: reboot_web.WebContext,
    partialRequest?: StoreV2.PartialChangesRequest,
    options?: { signal?: AbortSignal },
  ): Promise<[
      AsyncGenerator<StoreV2.ChangesResponse, void, unknown>,
      (newRequest: StoreV2.PartialChangesRequest) => void
    ]> {
    const request = StoreV2ChangesRequestToProtobuf(partialRequest);

    const [generator, setRequest] = reboot_web.reactively(
      {
        url: context.url,
        state: this.#state,
        method: "Changes",
        id: this.#id,
        requestType: store_pb.ChangesRequest,
        responseType: store_pb.ChangesResponse,
        request: request,
        signal: options?.signal,
        bearerToken: context.bearerToken,
        websockets: context.websockets,
      }
    );

    const setTypedRequest = (newRequest: StoreV2.PartialChangesRequest): void => {
      const typedRequest = StoreV2ChangesRequestToProtobuf(newRequest);
      setRequest(typedRequest);
    };

    async function* typedGenerator(): AsyncGenerator<StoreV2.ChangesResponse, void, unknown> {
     for await (const response of generator) {
      const typedResponse = StoreV2ChangesResponseFromProtobufShape(response);
      yield typedResponse;
      }
    };

    return [typedGenerator(), setTypedRequest];
  }

}

class _Idempotently {
  #stateRef: string;
  #idempotencyKey: string;

  constructor(id: string, idempotencyKey: string, options?: reboot_api.CallOptions) {
    this.#stateRef = reboot_api.stateIdToRef("dev.moment.differential.v1alpha2.StoreV2", id);
    this.#idempotencyKey = idempotencyKey;
  }

  async createTable(
    context: reboot_web.WebContext,
    partialRequest?: StoreV2.PartialCreateTableRequest,
    options?: { signal?: AbortSignal },
  ): Promise<StoreV2.CreateTableResponse> {
    const request = StoreV2CreateTableRequestToProtobuf(partialRequest);

    const responseProtobuf = await reboot_web.httpCall(
      {
        url: context.url,
        method: "dev.moment.differential.v1alpha2.StoreV2Methods/CreateTable",
        stateRef: this.#stateRef,
        requestType: store_pb.CreateTableRequest,
        responseType: store_pb.CreateTableResponse,
        abortedType: StoreV2CreateTableAborted,
        request: request,
        options: options,
        bearerToken: context.bearerToken,
        idempotencyKey: this.#idempotencyKey,
      });

    return StoreV2CreateTableResponseFromProtobufShape(responseProtobuf);
  }

  async dropTable(
    context: reboot_web.WebContext,
    partialRequest?: StoreV2.PartialDropTableRequest,
    options?: { signal?: AbortSignal },
  ): Promise<StoreV2.DropTableResponse> {
    const request = StoreV2DropTableRequestToProtobuf(partialRequest);

    const responseProtobuf = await reboot_web.httpCall(
      {
        url: context.url,
        method: "dev.moment.differential.v1alpha2.StoreV2Methods/DropTable",
        stateRef: this.#stateRef,
        requestType: store_pb.DropTableRequest,
        responseType: store_pb.DropTableResponse,
        abortedType: StoreV2DropTableAborted,
        request: request,
        options: options,
        bearerToken: context.bearerToken,
        idempotencyKey: this.#idempotencyKey,
      });

    return StoreV2DropTableResponseFromProtobufShape(responseProtobuf);
  }

  async ensureCreated(
    context: reboot_web.WebContext,
    partialRequest?: StoreV2.PartialEnsureCreatedRequest,
    options?: { signal?: AbortSignal },
  ): Promise<StoreV2.EnsureCreatedResponse> {
    const request = StoreV2EnsureCreatedRequestToProtobuf(partialRequest);

    const responseProtobuf = await reboot_web.httpCall(
      {
        url: context.url,
        method: "dev.moment.differential.v1alpha2.StoreV2Methods/EnsureCreated",
        stateRef: this.#stateRef,
        requestType: store_pb.EnsureCreatedRequest,
        responseType: store_pb.EnsureCreatedResponse,
        abortedType: StoreV2EnsureCreatedAborted,
        request: request,
        options: options,
        bearerToken: context.bearerToken,
        idempotencyKey: this.#idempotencyKey,
      });

    return StoreV2EnsureCreatedResponseFromProtobufShape(responseProtobuf);
  }

  async mutate(
    context: reboot_web.WebContext,
    partialRequest?: StoreV2.PartialMutateRequest,
    options?: { signal?: AbortSignal },
  ): Promise<StoreV2.MutateResponse> {
    const request = StoreV2MutateRequestToProtobuf(partialRequest);

    const responseProtobuf = await reboot_web.httpCall(
      {
        url: context.url,
        method: "dev.moment.differential.v1alpha2.StoreV2Methods/Mutate",
        stateRef: this.#stateRef,
        requestType: store_pb.MutateRequest,
        responseType: store_pb.MutateResponse,
        abortedType: StoreV2MutateAborted,
        request: request,
        options: options,
        bearerToken: context.bearerToken,
        idempotencyKey: this.#idempotencyKey,
      });

    return StoreV2MutateResponseFromProtobufShape(responseProtobuf);
  }

}

export class StoreV2WeakReference {
  #id: string;
  #options?: reboot_api.CallOptions;

  constructor(id: string) {
    this.#id = id;
  }

  get stateId(): string {
    return this.#id;
  }

  public reactively() {
    return new _Reactively(
      this.#id,
    );
  }

  public idempotently({ key }: { key: string }) {
    return new _Idempotently(
      this.#id,
      key,
    );
  }


  async createTable(
    context: reboot_web.WebContext,
    partialRequest?: StoreV2.PartialCreateTableRequest,
    options?: { signal?: AbortSignal, from_constructor?: boolean },
  ): Promise<StoreV2.CreateTableResponse> {

    const request = StoreV2CreateTableRequestToProtobuf(partialRequest);

    const stateRef = reboot_api.stateIdToRef(
      "dev.moment.differential.v1alpha2.StoreV2",
      this.#id,
    );
    const idempotencyKey = uuidv4();

    const protobufResponse = await reboot_web.httpCall(
      {
        url: context.url,
        method: "dev.moment.differential.v1alpha2.StoreV2Methods/CreateTable",
        stateRef: stateRef,
        requestType: store_pb.CreateTableRequest,
        responseType: store_pb.CreateTableResponse,
        abortedType: StoreV2CreateTableAborted,
        request: request,
        options: options,
        bearerToken: context.bearerToken,
        idempotencyKey: idempotencyKey,
      });

    return StoreV2CreateTableResponseFromProtobufShape(protobufResponse);
  }


  async dropTable(
    context: reboot_web.WebContext,
    partialRequest?: StoreV2.PartialDropTableRequest,
    options?: { signal?: AbortSignal, from_constructor?: boolean },
  ): Promise<StoreV2.DropTableResponse> {

    const request = StoreV2DropTableRequestToProtobuf(partialRequest);

    const stateRef = reboot_api.stateIdToRef(
      "dev.moment.differential.v1alpha2.StoreV2",
      this.#id,
    );
    const idempotencyKey = uuidv4();

    const protobufResponse = await reboot_web.httpCall(
      {
        url: context.url,
        method: "dev.moment.differential.v1alpha2.StoreV2Methods/DropTable",
        stateRef: stateRef,
        requestType: store_pb.DropTableRequest,
        responseType: store_pb.DropTableResponse,
        abortedType: StoreV2DropTableAborted,
        request: request,
        options: options,
        bearerToken: context.bearerToken,
        idempotencyKey: idempotencyKey,
      });

    return StoreV2DropTableResponseFromProtobufShape(protobufResponse);
  }


  async ensureCreated(
    context: reboot_web.WebContext,
    partialRequest?: StoreV2.PartialEnsureCreatedRequest,
    options?: { signal?: AbortSignal, from_constructor?: boolean },
  ): Promise<StoreV2.EnsureCreatedResponse> {

    const request = StoreV2EnsureCreatedRequestToProtobuf(partialRequest);

    const stateRef = reboot_api.stateIdToRef(
      "dev.moment.differential.v1alpha2.StoreV2",
      this.#id,
    );
    const idempotencyKey = uuidv4();

    const protobufResponse = await reboot_web.httpCall(
      {
        url: context.url,
        method: "dev.moment.differential.v1alpha2.StoreV2Methods/EnsureCreated",
        stateRef: stateRef,
        requestType: store_pb.EnsureCreatedRequest,
        responseType: store_pb.EnsureCreatedResponse,
        abortedType: StoreV2EnsureCreatedAborted,
        request: request,
        options: options,
        bearerToken: context.bearerToken,
        idempotencyKey: idempotencyKey,
      });

    return StoreV2EnsureCreatedResponseFromProtobufShape(protobufResponse);
  }


  async mutate(
    context: reboot_web.WebContext,
    partialRequest?: StoreV2.PartialMutateRequest,
    options?: { signal?: AbortSignal, from_constructor?: boolean },
  ): Promise<StoreV2.MutateResponse> {

    const request = StoreV2MutateRequestToProtobuf(partialRequest);

    const stateRef = reboot_api.stateIdToRef(
      "dev.moment.differential.v1alpha2.StoreV2",
      this.#id,
    );
    const idempotencyKey = uuidv4();

    const protobufResponse = await reboot_web.httpCall(
      {
        url: context.url,
        method: "dev.moment.differential.v1alpha2.StoreV2Methods/Mutate",
        stateRef: stateRef,
        requestType: store_pb.MutateRequest,
        responseType: store_pb.MutateResponse,
        abortedType: StoreV2MutateAborted,
        request: request,
        options: options,
        bearerToken: context.bearerToken,
        idempotencyKey: idempotencyKey,
      });

    return StoreV2MutateResponseFromProtobufShape(protobufResponse);
  }


  async snapshot(
    context: reboot_web.WebContext,
    partialRequest?: StoreV2.PartialSnapshotRequest,
    options?: { signal?: AbortSignal, from_constructor?: boolean },
  ): Promise<StoreV2.SnapshotResponse> {

    const request = StoreV2SnapshotRequestToProtobuf(partialRequest);

    const stateRef = reboot_api.stateIdToRef(
      "dev.moment.differential.v1alpha2.StoreV2",
      this.#id,
    );
    const idempotencyKey = uuidv4();

    const protobufResponse = await reboot_web.httpCall(
      {
        url: context.url,
        method: "dev.moment.differential.v1alpha2.StoreV2Methods/Snapshot",
        stateRef: stateRef,
        requestType: store_pb.SnapshotRequest,
        responseType: store_pb.SnapshotResponse,
        abortedType: StoreV2SnapshotAborted,
        request: request,
        options: options,
        bearerToken: context.bearerToken,
        idempotencyKey: idempotencyKey,
      });

    return StoreV2SnapshotResponseFromProtobufShape(protobufResponse);
  }


  async changes(
    context: reboot_web.WebContext,
    partialRequest?: StoreV2.PartialChangesRequest,
    options?: { signal?: AbortSignal, from_constructor?: boolean },
  ): Promise<StoreV2.ChangesResponse> {

    const request = StoreV2ChangesRequestToProtobuf(partialRequest);

    const stateRef = reboot_api.stateIdToRef(
      "dev.moment.differential.v1alpha2.StoreV2",
      this.#id,
    );
    const idempotencyKey = uuidv4();

    const protobufResponse = await reboot_web.httpCall(
      {
        url: context.url,
        method: "dev.moment.differential.v1alpha2.StoreV2Methods/Changes",
        stateRef: stateRef,
        requestType: store_pb.ChangesRequest,
        responseType: store_pb.ChangesResponse,
        abortedType: StoreV2ChangesAborted,
        request: request,
        options: options,
        bearerToken: context.bearerToken,
        idempotencyKey: idempotencyKey,
      });

    return StoreV2ChangesResponseFromProtobufShape(protobufResponse);
  }

}

export class StoreV2 {

  static WeakReference = StoreV2WeakReference;

  public static ref(
    id: string,
    options?: { bearerToken?: string }
  ) {
    return new StoreV2.WeakReference(id, options?.bearerToken);
  }



}

export namespace StoreV2 {
  export type WeakReference = typeof StoreV2.WeakReference.prototype;
}

